<template>
    <div id="popup" aria-hidden="true" class="popup popup-filter">
        <div class="popup__wrapper">
            <div class="popup__content">
                <div class="popup__top top-popup top-popup-filter">
                    <div class="top-popup__left top-popup__left--filter">
                        <span>{{ 'All Filters' | trans }}</span>
                    </div>
                    <button
                        type="button"
                        data-close
                        class="popup__close popup__close--filters"
                    ></button>
                </div>
                <form action="" class="popup-filter__form form-filter-popup" @submit.prevent="apply">
                    <div class="form-filter-popup__body">
                        <!-- Buy / Rent -->
                        <div v-if="showsOffer" class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Offer' | trans }}:</div>
                            <div class="form-filter-popup__options options options_default">
                                <div
                                    v-for="opt in offerOptions"
                                    :key="'offer_' + (opt.value || 'all')"
                                    class="options__item"
                                >
                                    <input
                                        type="radio"
                                        name="offer"
                                        :id="'offer_' + (opt.value || 'all')"
                                        class="options__input"
                                        :checked="form.offer === opt.value"
                                        @change="form.offer = opt.value"
                                    >
                                    <label :for="'offer_' + (opt.value || 'all')" class="options__label">
                                        <span class="options__text">{{ opt.label }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- City -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'City' | trans }}:</div>
                            <div
                                class="form-filter-popup__select custom-select-filter"
                                :class="{'_open': opened === 'city'}"
                            >
                                <button type="button" class="custom-select-filter__title" @click="toggle('city')">
                                    <span v-if="!form.city" class="custom-select-filter__title-any">{{ 'Any city' | trans }}</span>
                                    <span v-else>{{ labelOf(cities, form.city) }}</span>
                                </button>
                                <div class="custom-select-filter__body">
                                    <div class="custom-select-filter__content" :class="{'d-none': opened !== 'city'}">
                                        <div class="select-checkbox" @click="select('city', null)">
                                            <input type="checkbox" :checked="!form.city">
                                            <label>{{ 'Any city' | trans }}</label>
                                        </div>
                                        <div
                                            v-for="city in cities"
                                            :key="'city_' + city.slug"
                                            class="select-checkbox"
                                            @click="select('city', city.slug)"
                                        >
                                            <input type="checkbox" :checked="form.city === city.slug">
                                            <label>{{ city.label }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- District: only under a city that has any -->
                        <div v-if="districts.length > 0" class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'District' | trans }}:</div>
                            <div
                                class="form-filter-popup__select custom-select-filter"
                                :class="{'_open': opened === 'district'}"
                            >
                                <button type="button" class="custom-select-filter__title" @click="toggle('district')">
                                    <span v-if="!form.district" class="custom-select-filter__title-any">{{ 'Any district' | trans }}</span>
                                    <span v-else>{{ labelOf(districts, form.district) }}</span>
                                </button>
                                <div class="custom-select-filter__body">
                                    <div class="custom-select-filter__content" :class="{'d-none': opened !== 'district'}">
                                        <div class="select-checkbox" @click="select('district', null)">
                                            <input type="checkbox" :checked="!form.district">
                                            <label>{{ 'Any district' | trans }}</label>
                                        </div>
                                        <div
                                            v-for="district in districts"
                                            :key="'district_' + district.slug"
                                            class="select-checkbox"
                                            @click="select('district', district.slug)"
                                        >
                                            <input type="checkbox" :checked="form.district === district.slug">
                                            <label>{{ district.label }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Property type -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Property type' | trans }}:</div>
                            <div
                                class="form-filter-popup__select custom-select-filter"
                                :class="{'_open': opened === 'type'}"
                            >
                                <button type="button" class="custom-select-filter__title" @click="toggle('type')">
                                    <span v-if="!form.type" class="custom-select-filter__title-any">{{ 'Any type' | trans }}</span>
                                    <span v-else>{{ labelOf(types, form.type) }}</span>
                                </button>
                                <div class="custom-select-filter__body">
                                    <div class="custom-select-filter__content" :class="{'d-none': opened !== 'type'}">
                                        <div class="select-checkbox" @click="select('type', null)">
                                            <input type="checkbox" :checked="!form.type">
                                            <label>{{ 'Any type' | trans }}</label>
                                        </div>
                                        <div
                                            v-for="type in types"
                                            :key="'type_' + type.slug"
                                            class="select-checkbox"
                                            @click="select('type', type.slug)"
                                        >
                                            <input type="checkbox" :checked="form.type === type.slug">
                                            <label>{{ type.label }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Price: a slider that SNAPS to the catalog's buckets -->
                        <div v-if="has('price') && priceBuckets.length > 0" class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Price' | trans }}:</div>
                            <div class="form-filter-popup__price price-form-filter mls-filter__price">
                                <div class="price-form-filter__top">
                                    <div class="price-form-filter__left">
                                        <div class="price-form-filter__wp">
                                            <input
                                                type="text"
                                                inputmode="numeric"
                                                autocomplete="off"
                                                class="price-form-filter__input"
                                                :placeholder="trans('From') + ' ' + dollars(priceBuckets[0])"
                                                :value="form.price_min ? dollars(form.price_min) : ''"
                                                @change="typePrice('price_min', $event)"
                                            >
                                        </div>
                                        <img :src="currencyIconSrc" alt="">
                                        <div class="price-form-filter__wp">
                                            <input
                                                type="text"
                                                inputmode="numeric"
                                                autocomplete="off"
                                                class="price-form-filter__input"
                                                :placeholder="trans('To') + ' ' + dollars(priceBuckets[priceBuckets.length - 1])"
                                                :value="form.price_max ? dollars(form.price_max) : ''"
                                                @change="typePrice('price_max', $event)"
                                            >
                                        </div>
                                        <img :src="currencyIconSrc" alt="">
                                    </div>
                                </div>
                                <div class="price-form-filter__range_wp">
                                    <div ref="priceSlider" class="price-form-filter__range"></div>
                                </div>
                            </div>
                        </div>

                        <!-- Bedrooms: an exact count (SPEC-0018); bathrooms: "N+" -->
                        <div v-if="has('beds')" class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Bedrooms' | trans }}:</div>
                            <div class="form-filter-popup__options options options_round">
                                <div v-for="n in steps.beds" :key="'beds_' + n" class="options__item">
                                    <input
                                        type="checkbox"
                                        :id="'beds_' + n"
                                        class="options__input"
                                        :checked="form.beds === n"
                                        @change="pick('beds', n)"
                                    >
                                    <label :for="'beds_' + n" class="options__label">
                                        <span class="options__text">{{ n }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div v-if="has('baths')" class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Bathrooms' | trans }}:</div>
                            <div class="form-filter-popup__options options options_round">
                                <div v-for="n in steps.baths_min" :key="'baths_' + n" class="options__item">
                                    <input
                                        type="checkbox"
                                        :id="'baths_' + n"
                                        class="options__input"
                                        :checked="form.baths_min === n"
                                        @change="pick('baths_min', n)"
                                    >
                                    <label :for="'baths_' + n" class="options__label">
                                        <span class="options__text">{{ n }}+</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Area / year built: "from N". The area pills are in the unit
                             picked in the language popup (m² / ft²); the popup has no switch. -->
                        <div v-if="has('living_area')" class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Area' | trans }}:</div>
                            <div class="form-filter-popup__options options options_round mls-filter__pills">
                                <div v-for="n in areaSteps" :key="'area_' + areaUnit + '_' + n" class="options__item">
                                    <input
                                        type="checkbox"
                                        :id="'area_' + areaUnit + '_' + n"
                                        class="options__input"
                                        :checked="form.area_min === n"
                                        @change="pickArea(n)"
                                    >
                                    <label :for="'area_' + areaUnit + '_' + n" class="options__label">
                                        <span class="options__text">{{ number(n) }} {{ areaUnitLabel }}+</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div v-if="has('year_built')" class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Year built' | trans }}:</div>
                            <div class="form-filter-popup__options options options_round mls-filter__pills">
                                <div v-for="n in steps.year_min" :key="'year_' + n" class="options__item">
                                    <input
                                        type="checkbox"
                                        :id="'year_' + n"
                                        class="options__input"
                                        :checked="form.year_min === n"
                                        @change="pick('year_min', n)"
                                    >
                                    <label :for="'year_' + n" class="options__label">
                                        <span class="options__text">{{ n }}+</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Flags. "New construction" is the new-building filter page's
                             own floor (year_min 2020), so it shares Year built's value. -->
                        <div v-if="has('waterfront') || has('pool') || newConstructionYear" class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Features' | trans }}:</div>
                            <div class="filter-options">
                                <div v-if="has('waterfront')" class="options__item">
                                    <input type="checkbox" id="flag_waterfront" class="options__input" v-model="form.waterfront">
                                    <label for="flag_waterfront" class="options__label">
                                        <span class="options__text">{{ 'Waterfront' | trans }}</span>
                                    </label>
                                </div>
                                <div v-if="has('pool')" class="options__item">
                                    <input type="checkbox" id="flag_pool" class="options__input" v-model="form.pool">
                                    <label for="flag_pool" class="options__label">
                                        <span class="options__text">{{ 'Pool' | trans }}</span>
                                    </label>
                                </div>
                                <div v-if="newConstructionYear" class="options__item">
                                    <input
                                        type="checkbox"
                                        id="flag_new_construction"
                                        class="options__input"
                                        :checked="form.year_min === newConstructionYear"
                                        @change="pick('year_min', newConstructionYear)"
                                    >
                                    <label for="flag_new_construction" class="options__label">
                                        <span class="options__text">{{ 'New construction' | trans }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="form-filter-popup__footer footer-form-filter">
                    <button type="button" class="reset-filters" @click="reset">
                        <img src="/img/reset.svg" alt="">
                        <span>{{ 'Reset filter' | trans }}</span>
                        <span>{{ 'Reset' | trans }}</span>
                    </button>
                    <button type="button" data-close class="blue-btn apply-filters" @click="apply">
                        <span>{{ showLabel }}</span>
                        <span>{{ showLabel }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import noUiSlider from 'nouislider';
import { buildCatalogUrl } from './filterPageUrl';

/**
 * The site-wide filter popup, searching the MLS catalog (SPEC-0016).
 *
 * Where a selection goes is filterPageUrl.js (SPEC-0018 §5.2): a picked type becomes
 * the path — `/{city}/{type}`, `/real-estate/{type}` — and a selection naming a
 * filter page lands on it (`/miami/condos/pool`); a city alone is the city page and
 * nothing at all is `/real-estate`. The count behind the button asks /idx/count with
 * the same axes the landing page will have. The popup
 * offers exactly the values that page accepts, and nothing in between: a price
 * outside the admin's buckets or an area outside the steps is not a narrower page,
 * it is a 404 (CatalogFilters::isAddressable). That is why the price slider
 * snaps to the buckets instead of moving by dollars.
 *
 * State is the URL. On a catalog page the popup opens with the page's own path axes
 * and filters in force (window.idxFilterContext); elsewhere it opens empty. Nothing is kept in a store or in localStorage —
 * the previous popup did, and the selection it kept was one nobody could see.
 *
 * `options` comes from IDX\Services\Catalog\FilterOptions through the blade
 * partial; the home-page filter (MainPageFilter) reads the same payload.
 */
const EMPTY = {
    offer: null,
    city: null,
    district: null,
    type: null,
    price_min: null,
    price_max: null,
    beds: null,
    baths_min: null,
    area_min: null,
    // 'm2' when area_min is in square metres; square feet, the feed's unit, has none.
    area_unit: null,
    year_min: null,
    waterfront: false,
    pool: false,
    // No control in the popup any more: kept so a catalog page's own furnished / search
    // filter rides along when the visitor narrows it here, and Reset clears it.
    furnished: null,
    q: '',
};

const NUMERIC = ['price_min', 'price_max', 'beds', 'baths_min', 'area_min', 'year_min'];

const AREA_M2 = 'm2';
const AREA_FT2 = 'ft2';

/** How long "Show" waits for /idx/count to name the filter page before building the address alone. */
const APPLY_WAIT_MS = 2000;

/** Facet name → the form field it gates, for TYPE_DENIED. */
const FACET_FIELDS = {
    beds: 'beds',
    baths: 'baths_min',
    living_area: 'area_min',
    year_built: 'year_min',
    pool: 'pool',
    waterfront: 'waterfront',
    furnished: 'furnished',
};

export default {
    name: 'PopupFilter',

    props: {
        options: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: { ...EMPTY },
            opened: null,
            // The "Show N offers" number: null until the popup has been opened —
            // a page load must not cost a count query for a popup nobody opens.
            liveCount: null,
            countLoading: false,
            // The filter page /idx/count named for the selection it answered (liveQuery):
            // only the server knows which filter pages answer rather than 404.
            liveSegment: null,
            liveQuery: null,
            // The catalog page the popup was opened on, and the sort in force there —
            // the popup has no sort control, so a sort page keeps its order.
            context: null,
            carriedSort: null,
            // The unit the area pills are shown in: the visitor's own choice from the
            // language popup. Only a picked value puts it in the form (area_unit).
            areaUnit: window.measurementUnitSystem === 'metric' ? AREA_M2 : AREA_FT2,
        };
    },

    computed: {
        areaSteps() {
            const steps = this.options.steps || {};
            return (this.areaUnit === AREA_M2 ? steps.area_min_m2 : steps.area_min) || [];
        },
        areaUnitLabel() {
            return this.areaUnit === AREA_M2 ? 'm²' : 'ft²';
        },
        cities() {
            return this.options.cities || [];
        },
        city() {
            return this.cities.find((c) => c.slug === this.form.city) || null;
        },
        districts() {
            return this.city ? this.city.districts || [] : [];
        },
        types() {
            const all = this.options.types || [];
            if (!this.city) return all;

            // The registry bar narrows its type picker to what the picked city
            // actually serves; the popup does the same.
            const allowed = this.city.types || [];
            return all.filter((t) => allowed.includes(t.slug));
        },
        priceBuckets() {
            return this.options.price_buckets || [];
        },
        /** The year the new-building filter page starts at (filter-pages.php), when that
         *  page is enabled and the year is one of the Year built steps. */
        newConstructionYear() {
            if (!this.has('year_built')) return null;
            const segment = (this.options.segments || []).find((seg) => seg.slug === 'new-building');
            const year = segment && segment.query ? Number(segment.query.year_min) : NaN;
            return (this.steps.year_min || []).includes(year) ? year : null;
        },
        steps() {
            return this.options.steps || {};
        },
        showsOffer() {
            return this.options.offer === true;
        },
        offerOptions() {
            return [
                { value: null, label: this.trans('All') },
                { value: 'sale', label: this.trans('Buy') },
                { value: 'rent', label: this.trans('Rent') },
            ];
        },
        /** The catalog's price buckets are the feed's US dollars, whatever currency the
         *  visitor reads prices in elsewhere: the sign beside them says so. */
        currencyIconSrc() {
            return '/img/volute/usd.svg';
        },
        showLabel() {
            if (this.countLoading) return this.trans('Show') + ' …';
            if (this.liveCount === null) return this.trans('Show');
            return `${this.trans('Show')} ${this.number(this.liveCount)} ${this.trans('offers')}`;
        },
        catalogPath() {
            try {
                return new URL(this.options.url, window.location.origin).pathname;
            } catch (e) {
                return '/real-estate';
            }
        },
    },

    watch: {
        form: {
            deep: true,
            handler() {
                // Only once the popup has asked for a count: before that the form
                // changes on mount (readFromUrl) and nobody is looking.
                if (this.liveCount !== null || this.countLoading) this.scheduleCount();
            },
        },
        'form.city'() {
            // A district belongs to its city and a type may be closed in another.
            if (this.form.district && !this.districts.some((d) => d.slug === this.form.district)) {
                this.form.district = null;
            }
            if (this.form.type && !this.types.some((t) => t.slug === this.form.type)) {
                this.form.type = null;
            }
        },
        'form.price_min'() {
            this.syncPriceSlider();
        },
        'form.price_max'() {
            this.syncPriceSlider();
        },
        'form.type'() {
            // A facet the picked type does not have (beds under land) is dropped
            // from the form as well as from the screen, so it cannot ride along
            // in the query string as a filter the page then ignores.
            Object.keys(FACET_FIELDS).forEach((facet) => {
                if (!this.has(facet)) {
                    const field = FACET_FIELDS[facet];
                    this.form[field] = typeof EMPTY[field] === 'boolean' ? false : null;
                }
            });
            if (this.form.area_min === null) this.form.area_unit = null;
        },
    },

    methods: {
        /**
         * The slider runs over positions, not dollars: 0 is "no minimum", the
         * buckets sit at 1..N, and N+1 is "no maximum". Both handles share the
         * scale, so a handle can only ever land on a value the catalog accepts.
         */
        initPriceSlider() {
            const el = this.$refs.priceSlider;
            if (!el || this.priceBuckets.length === 0) return;
            if (el.noUiSlider) el.noUiSlider.destroy();

            const last = this.priceBuckets.length + 1;

            noUiSlider.create(el, {
                start: this.pricePositions(),
                connect: true,
                step: 1,
                range: { min: 0, max: last },
                format: {
                    to: (v) => Math.round(v),
                    from: (v) => Number(v),
                },
            });

            el.noUiSlider.on('update', (values) => {
                const [lo, hi] = values.map((v) => Math.round(Number(v)));
                const min = lo <= 0 ? null : this.priceBuckets[lo - 1];
                const max = hi >= last ? null : this.priceBuckets[hi - 1];
                if (this.form.price_min !== min) this.form.price_min = min;
                if (this.form.price_max !== max) this.form.price_max = max;
            });
        },

        /** Where the handles stand for the current form values. */
        pricePositions() {
            const last = this.priceBuckets.length + 1;
            const at = (value) => {
                const i = this.priceBuckets.indexOf(value);
                return i === -1 ? null : i + 1;
            };
            return [
                this.form.price_min ? at(this.form.price_min) ?? 0 : 0,
                this.form.price_max ? at(this.form.price_max) ?? last : last,
            ];
        },

        /** Move the handles to the form — unless they are already there (a drag
         *  updates the form, and setting the slider back mid-drag would fight it). */
        syncPriceSlider() {
            const el = this.$refs.priceSlider;
            if (!el || !el.noUiSlider) return;

            const want = this.pricePositions();
            const have = el.noUiSlider.get().map((v) => Math.round(Number(v)));
            if (have[0] !== want[0] || have[1] !== want[1]) {
                el.noUiSlider.set(want);
            }
        },

        /**
         * A typed amount lands on a bucket, never between two: the floor bucket for
         * a minimum, the ceiling bucket for a maximum — so the range can only
         * widen towards what was typed, never exclude it. Below the first / above
         * the last bucket means "no bound".
         */
        typePrice(field, event) {
            const raw = parseInt(String(event.target.value).replace(/[^\d]/g, ''), 10);
            let value = null;

            if (!Number.isNaN(raw) && raw > 0) {
                const below = this.priceBuckets.filter((b) => b <= raw);
                const above = this.priceBuckets.filter((b) => b >= raw);
                value = field === 'price_min'
                    ? (below.length ? below[below.length - 1] : null)
                    : (above.length ? above[0] : null);
            }

            this.form[field] = value;
            // Re-render the input even when the snapped value did not change.
            event.target.value = value ? this.dollars(value) : '';
        },

        dollars(value) {
            return '$' + Number(value).toLocaleString('en-US');
        },

        has(facet) {
            const enabled = this.options.facets || [];
            if (!enabled.includes(facet)) return false;

            const denied = (this.options.type_denied || {})[facet] || [];
            return !(this.form.type && denied.includes(this.form.type));
        },

        toggle(name) {
            this.opened = this.opened === name ? null : name;
        },

        select(field, value) {
            this.form[field] = value;
            this.opened = null;
        },

        /** Round buttons: the same value again clears it. */
        pick(field, value) {
            this.form[field] = this.form[field] === value ? null : value;
        },

        /** An area floor carries the unit it was picked in. */
        pickArea(value) {
            this.pick('area_min', value);
            this.form.area_unit = this.form.area_min !== null && this.areaUnit === AREA_M2 ? AREA_M2 : null;
        },

        labelOf(list, slug) {
            const found = list.find((item) => item.slug === slug);
            return found ? found.label : slug;
        },

        money(value) {
            const v = Number(value);
            if (v >= 1000000) {
                return '$' + String(Math.round((v / 1000000) * 10) / 10).replace(/\.0$/, '') + 'M';
            }
            return '$' + Math.round(v / 1000) + 'K';
        },

        number(value) {
            return Number(value).toLocaleString('en-US');
        },

        reset() {
            this.form = { ...EMPTY };
            this.opened = null;
            this.syncPriceSlider();
        },

        query() {
            const params = new URLSearchParams();
            Object.keys(EMPTY).forEach((key) => {
                const value = this.form[key];
                if (value === null || value === '' || value === false) return;
                params.set(key, value === true ? '1' : String(value));
            });
            return params.toString();
        },

        /** `named` is the filter page /idx/count chose; without it the builder chooses alone. */
        target(named) {
            return buildCatalogUrl(this.options, this.context, { ...this.form, sort: this.carriedSort }, named);
        },

        /**
         * "Show" goes where /idx/count said for this very selection — waited for when
         * the answer is stale — so a never-populated filter page (404) is not linked.
         * Without an answer the local builder decides alone.
         */
        async apply() {
            // A second click would abort the answer the first one waits for.
            if (this._applying) return;
            this._applying = true;

            // So would the debounced count of the last change, firing mid-wait.
            clearTimeout(this._countTimer);

            const query = this.countQuery();
            if (this.liveQuery !== query) await this.fetchCount(APPLY_WAIT_MS);

            const url = this.target(this.liveQuery === query ? this.liveSegment : undefined).url;
            // The phone's catalog map stays open over the new results (scripts/place-memory).
            if (window.bdRememberPlace) window.bdRememberPlace(url);
            window.location.href = url;
            // Navigation is under way; a page restored from the back-forward cache must
            // not come back with a dead button.
            this._applying = false;
        },

        /** The count asks about the page the selection lands on: its child type, the
         *  segment of the page the popup opened on and the sort it carries. The server
         *  picks the filter page and counts its sale-only market. */
        countQuery() {
            const target = this.target();
            const params = new URLSearchParams(this.query());
            if (target.child) params.set('child', target.child);
            if (target.category) params.set('category', target.category);
            if (target.current) params.set('segment', target.current);
            if (this.carriedSort) params.set('sort', this.carriedSort);
            return params.toString();
        },

        /** On a catalog page the popup reflects the path and the filters in force. */
        readFromUrl() {
            const context = window.idxFilterContext || null;
            let params;

            if (context) {
                // Only a plain object — see filterContext in CatalogController.
                const values = context.values;
                params = values && typeof values === 'object' && !Array.isArray(values) ? values : {};
            } else if (window.location.pathname === this.catalogPath) {
                params = Object.fromEntries(new URLSearchParams(window.location.search));
            } else {
                return;
            }

            const next = { ...EMPTY };

            Object.keys(EMPTY).forEach((key) => {
                const raw = params[key];
                if (raw === undefined || raw === null) return;

                if (typeof EMPTY[key] === 'boolean') {
                    next[key] = raw === true || raw === 1 || raw === '1' || raw === 'true';
                } else if (NUMERIC.includes(key)) {
                    const n = parseInt(String(raw), 10);
                    next[key] = Number.isNaN(n) ? null : n;
                } else {
                    next[key] = String(raw) || null;
                }
            });

            if (context) {
                // The path's own axes: /miami/condos names its city and type in the path.
                ['city', 'district', 'type'].forEach((key) => {
                    if (context[key]) next[key] = context[key];
                });
                this.context = context;
                this.carriedSort = typeof params.sort === 'string' && params.sort !== '' ? params.sort : null;
            }

            if (next.q === null) next.q = '';
            next.area_unit = next.area_unit === AREA_M2 && next.area_min !== null ? AREA_M2 : null;
            // A floor names its unit; with none picked the switch stays where it was.
            if (next.area_min !== null) this.areaUnit = next.area_unit ? AREA_M2 : AREA_FT2;
            this.form = next;
        },

        /**
         * Debounced and cancellable: a slider drag changes the form several times
         * a second, and only the last state is worth a round-trip. The server
         * caches the answer per criteria, so repeats of a popular combination do
         * not reach the database at all.
         */
        scheduleCount() {
            clearTimeout(this._countTimer);
            this._countTimer = setTimeout(() => this.fetchCount(), 450);
        },

        /** `timeout` (ms) gives up on a slow answer — "Show" must not hang on it. */
        async fetchCount(timeout = 0) {
            if (!this.options.count_url) return;

            if (this._countAbort) this._countAbort.abort();
            const controller = new AbortController();
            this._countAbort = controller;
            this.countLoading = true;
            const timer = timeout ? setTimeout(() => controller.abort(), timeout) : null;

            try {
                const query = this.countQuery();
                const response = await fetch(this.options.count_url + (query ? '?' + query : ''), {
                    signal: controller.signal,
                    headers: { Accept: 'application/json' },
                    credentials: 'same-origin',
                });
                if (!response.ok) throw new Error(String(response.status));
                const data = await response.json();
                if (this._countAbort === controller) {
                    this.liveCount = Number(data.count);
                    this.liveSegment = data.segment || null;
                    this.liveQuery = query;
                }
            } catch (e) {
                // Aborted or failed: the button falls back to a plain "Show".
                if (e.name !== 'AbortError' && this._countAbort === controller) {
                    this.liveCount = null;
                    this.liveQuery = null;
                }
            } finally {
                clearTimeout(timer);
                if (this._countAbort === controller) this.countLoading = false;
            }
        },

        /** The popup opener flips aria-hidden; the first opening asks for a count. */
        watchOpening() {
            if (!('MutationObserver' in window)) return;

            this._opening = new MutationObserver(() => {
                if (this.$el.getAttribute('aria-hidden') === 'false' && this.liveCount === null && !this.countLoading) {
                    this.fetchCount();
                }
            });
            this._opening.observe(this.$el, { attributes: true, attributeFilter: ['aria-hidden'] });
        },

        onDocumentClick(e) {
            if (this.opened && !(e.target instanceof Element && e.target.closest('.custom-select-filter'))) {
                this.opened = null;
            }
        },
    },

    mounted() {
        this.readFromUrl();
        this.$nextTick(() => this.initPriceSlider());
        this.watchOpening();
        document.addEventListener('click', this.onDocumentClick);
    },

    beforeDestroy() {
        const el = this.$refs.priceSlider;
        if (el && el.noUiSlider) el.noUiSlider.destroy();
        if (this._opening) this._opening.disconnect();
        clearTimeout(this._countTimer);
        if (this._countAbort) this._countAbort.abort();
        document.removeEventListener('click', this.onDocumentClick);
    },
};
</script>

<style scoped>
.d-none {
    display: none;
}
.custom-select-filter__title {
    overflow: hidden;
}
/* "1,000 ft²+" and "1980+" do not fit a 40px circle: the global sheet pads only
   the first pill of a row (.options__item:first-child), so the rest are padded here. */
.mls-filter__pills .options__label {
    width: auto;
    min-width: 40px;
    padding-left: 16px;
    padding-right: 16px;
    white-space: nowrap;
}
/* The global sheet caps the slider at 557px because the row used to hold the
   "per object / per ft²" switch on its right. The switch is gone, so both the
   inputs and the slider take the whole row. */
.mls-filter__price .price-form-filter__range {
    max-width: none;
}
/* On a phone the area and year rows scroll sideways instead of wrapping. */
@media (max-width: 767.98px) {
    .mls-filter__pills {
        flex-wrap: nowrap;
        overflow-x: auto;
        scrollbar-width: none;
    }
    .mls-filter__pills::-webkit-scrollbar {
        display: none;
    }
    .mls-filter__pills .options__item {
        flex: 0 0 auto;
    }
}
</style>
